export default __webpack_public_path__ + "assets/images/mastercard.3fa7aeb1ba489d42cbdd96af36cdec49.svg";